<script setup lang="ts">
import { ref, watch } from 'vue';
import { useState, useGetters } from '@/composables/useVuexHelpers';
import { EventBus } from '@/assets/js/event-bus';

interface MenuPosition {
  x: number;
  y: number;
}

interface Props {
  menuPosition: MenuPosition;
  nodeMenu: boolean;
}

const props = defineProps<Props>();

const { menuFadeOut } = useState(['menuFadeOut']);
const { userId } = useGetters(['userId']);

const showNodeMenu = ref(false);

watch(
  () => props.nodeMenu,
  newVal => {
    if (!newVal) {
      showNodeMenu.value = false;
    }
  }
);
</script>

<template>
  <div
    id="annotations-menu"
    :style="{
      left: `calc(${menuPosition.x}px)`,
      top: `calc(${menuPosition.y}px)`,
    }"
    class="uk-flex annotations-menu"
  >
    <div
      class="uk-background-secondary uk-light uk-padding-small uk-border-rounded"
      :class="{
        fadeOut: menuFadeOut,
      }"
    >
      <div
        uk-icon="list"
        class="annotations-menu-item"
        :class="{
          [`annotations-menu-${userId}`]: true,
        }"
        @click="
          () => {
            showNodeMenu = true;
          }
        "
      />
    </div>
    <div
      class="uk-flex node-menu"
      :class="{
        'node-hide': !showNodeMenu,
      }"
    >
      <div class="arrow-left"></div>
      <div
        class="uk-background-secondary uk-light uk-padding-small uk-border-rounded"
        :class="{
          fadeOut: menuFadeOut,
        }"
        style="left: 100%; position: absolute; width: 150px; font-size: var(--global-font-size)"
      >
        <div
          class="annotations-menu-item node-menu-item"
          @click="EventBus.emit('addnode.option', 'addbelownode')"
          :class="{
            [`annotations-menu-${userId}`]: true,
          }"
        >
          Add Below Node
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.arrow-left {
  width: 13px;
  margin-top: 20px;
  height: 25px;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-right: 15px solid #254858;
}

.node-menu-item {
  &:hover {
    color: white;
  }
}

.node-menu {
  transition:
    width 2s,
    opacity 2s;
  width: auto;
  opacity: 1;
}

.node-hide {
  width: 0 !important;
  opacity: 0 !important;
  display: none;
}
</style>
